const tooltipPopperSx = { zIndex: '9999 !important' };

export const tooltipSlotProps = { popper: { sx: tooltipPopperSx } };

// Same token as the theme's MuiDivider; collapses when no action renders (e.g. an approved task).
export const footerStyles = {
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
  paddingTop: '24px',
  '&:empty': {
    display: 'none',
  },
};
